import { createSelector } from '@reduxjs/toolkit';
import { selfMsgSelector } from './self';

const filterSelector = createSelector(selfMsgSelector, (messages) => messages.filters);

export default filterSelector;
